import { render } from "./RegistrationVerifyNumber.vue?vue&type=template&id=28b857bd&scoped=true&ts=true"
import script from "./RegistrationVerifyNumber.vue?vue&type=script&lang=ts"
export * from "./RegistrationVerifyNumber.vue?vue&type=script&lang=ts"

import "./RegistrationVerifyNumber.vue?vue&type=style&index=0&id=28b857bd&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b857bd"]])

export default __exports__